export default __webpack_public_path__ + "static/17-41f0792c648e4b522587acc73a8e6191.jpg";